import {HamburgerMenu} from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/HamburgerMenu';
import {MegaNavVariantStoreProvider} from '~/common/components/MegaNav/MegaNavVariant/components/StoreProvider';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {Favorites} from './components/Favorites/Favorites';
import {Login} from './components/Login/Login';
import {Logo} from './components/Logo/Logo';
import {NavigationLinks} from './components/NavigationLinks/NavigationLinks';
import {Notifications} from './components/Notifications/Notifications';

import * as styles from './GlobalNav.module.scss';

export const GlobalNav = () => {
  const isLargishAndUp = useIsLargishAndUp();

  return (
    <MegaNavVariantStoreProvider>
      <div className={styles.localNavContainer}>
        <div className={styles.localNavLeftSection}>
          <Logo />
          {isLargishAndUp && <NavigationLinks />}
        </div>
        <div className={styles.localNavRightSection}>
          <Favorites />
          <Notifications />
          <Login />
          <HamburgerMenu />
        </div>
      </div>
    </MegaNavVariantStoreProvider>
  );
};
